import styled from 'styled-components';

export const Divider = styled.div`
  width: 100%;
  margin-bottom: ${({ gap = 0 }) => gap}px;

  ${({ theme }) => theme.media.phone`
    margin-bottom: ${({ gap = 0, mobileGap = 0 }) => mobileGap || gap}px;
  `}
`;

export const Separator = styled.hr`
  margin: 0;
  border: 0;
  border-bottom: 1px solid ${({ borderColor }) => borderColor};
`;
